module.exports = __webpack_public_path__ + "static/media/zfq_logo.70869446.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/imgs/zfq_logo.jpg
// module id = 1824
// module chunks = 0